import React from "react";

const Projects = () => {
  return (
    <div id="project " className="dark:text-[#E0E2DB]">
      <h2 className="dark:text-[#e6af2e] font-bold text-4xl py-7">Projects</h2>
      <p>
        Explore the project further by delving into the source code. Click
        'Explore Code' to view the codebase. For a hands-on experience and to
        interact with the live demo, click 'Try Demo'.
      </p>
      <h1
        id="frontend"
        className=" dark:text-[#e6af2e] font-bold text-3xl py-5"
      >
        FrontEnd projects :
      </h1>
      {/* cards */}
      <div className="grid grid-cols-1  md:grid-cols-3 gap-8">
        <div className=" hover:scale-105 rounded-xl relative border">
          <img
            src="https://user-images.githubusercontent.com/62178820/272033594-4614df4e-c70b-4840-b8e7-6fd2d4f53b3c.jpeg"
            alt=""
            className="rounded-xl"
          />
          <div className="px-7 py-3">
            <h1 className="text-3xl py-2 lg:text-4xl font-semibold">
              Weatherly
            </h1>
            <p>
              A simple React app that fetches and displays real-time weather
              information using OpenWeatherMap API. Built with React and
              tailwind css.
            </p>
            <div className="lg:mt-2 md:mt-16 grid grid-cols-2 gap-6">
              <a
                href="https://github.com/faicalbounedjar/Weatherly-React-App"
                className=" p-3 rounded-lg my-3 bg-[#511730] hover:bg-[#7f3253]  duration-300 dark:bg-[#e6af2e] dark:hover:bg-[#9e7a25] text-white dark:text-black flex justify-center"
              >
                Explore Code
              </a>
              <button
                disabled
                className=" disabled: p-3 rounded-lg my-3 bg-[#511730]   duration-300 dark:bg-[#e6af2e]  text-white dark:text-black disabled cursor-not-allowed flex justify-center"
              >
                Try Demo
              </button>
            </div>
          </div>
        </div>
        <div className=" hover:scale-105  rounded-xl relative border">
          <img
            src="https://user-images.githubusercontent.com/62178820/272042535-f294b52b-8309-4357-9ec1-02188743f3ba.jpeg"
            alt=""
            className=" relative rounded-xl "
          />
          <div className="px-7 py-3">
            <h1 className="text-3xl py-2 lg:text-3xl font-semibold">Foodly</h1>
            <p>
              A React and Tailwind CSS-based UI clone of Uber Eats, following
              the design concept by Clint from Code Commerce. Responsive for
              mobile devices and crafted to showcase frontend skills.
            </p>
            <div className=" lg:mt-0 md:mt-3 grid grid-cols-2 gap-6">
              <a
                href="https://github.com/faicalbounedjar/Foodly-React-Tailwind"
                className=" p-3 rounded-lg my-3 bg-[#511730] hover:bg-[#7f3253]  duration-300 dark:bg-[#e6af2e] dark:hover:bg-[#9e7a25] text-white dark:text-black flex justify-center"
              >
                Explore Code
              </a>
              <a
                href="https://foodly-fb.vercel.app/"
                className=" p-3 rounded-lg my-3 bg-[#511730] hover:bg-[#7f3253]  duration-300 dark:bg-[#e6af2e] dark:hover:bg-[#9e7a25] text-white dark:text-black  flex justify-center"
              >
                Try Demo
              </a>
            </div>
          </div>
        </div>
        <div className=" hover:scale-105  rounded-xl relative border">
          <img
            src="https://user-images.githubusercontent.com/62178820/272039591-50eddc10-9bc4-437b-840b-c4a2c25dafdf.jpeg"
            alt=""
            className="rounded-xl"
          />
          <div className="px-7 py-3">
            <h1 className="text-3xl py-2 lg:text-4xl font-semibold">
              To Do app
            </h1>
            <p>
              A simple to do application , that saves data to local storage
              developed using React tailwind css
            </p>
            <div className=" lg:mt-8 md:mt-24 grid grid-cols-2 gap-6">
              <a
                href="https://github.com/faicalbounedjar/Todo_React_LocalStorage"
                className=" p-3 rounded-lg my-3 bg-[#511730] hover:bg-[#7f3253]  duration-300 dark:bg-[#e6af2e] dark:hover:bg-[#9e7a25] text-white dark:text-black flex justify-center"
              >
                Explore Code
              </a>
              <a
                href="https://reacttodo-faicalbounedjar.vercel.app/"
                className=" p-3 rounded-lg my-3 bg-[#511730] hover:bg-[#7f3253]  duration-300 dark:bg-[#e6af2e] dark:hover:bg-[#9e7a25] text-white dark:text-black  flex justify-center"
              >
                Try Demo
              </a>
            </div>
          </div>
        </div>
      </div>
      <h1 id="backend" className=" dark:text-[#e6af2e] font-bold text-3xl py-5">
        Backend projects :
      </h1>
      {/* cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <a
          onClick={() => {
            alert("dont forget to leave a star <3");
          }}
          href="https://github.com/faicalbounedjar/BlogApi_Node_Express_Sequelize"
          className="hover:scale-105 cursor-pointer rounded-xl relative border  p-8"
        >
          <h1 className="text-3xl font-semibold py-4">Blog Api</h1>
          <p className=" text-justify">
            for this backend project I used express ,nodejs and sequelize which
            is an orm (object relational mapping) tool to simplify data
            interaction by treating database entities as javascript objects,
          </p>
          <div className="grid grid-cols-1 ">
            <a
              href="https://github.com/faicalbounedjar/BlogApi_Node_Express_Sequelize"
              className=" p-3 rounded-lg my-3 bg-[#511730] hover:bg-[#7f3253]  duration-300 dark:bg-[#e6af2e] dark:hover:bg-[#9e7a25] text-white dark:text-black flex justify-center"
            >
              Explore Code
            </a>
          </div>
        </a>
      </div>
    </div>
  );
};

export default Projects;
